import { NestedTreeControl } from '@angular/cdk/tree';
import { Component, EventEmitter, Output } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { OrganizationUnitDto, OrganizationUnitServiceProxy } from '@shared/service-proxies/service-proxies';

@Component({
  selector: 'app-organization-tree-check-box',
  templateUrl: './organization-tree-check-box.component.html',
  styleUrls: ['./organization-tree-check-box.component.css']
})
export class OrganizationTreeCheckBoxComponent {
  @Output() clicked = new EventEmitter<OrganizationUnitDto[]>();
  treeControl = new NestedTreeControl<OrganizationUnitDto>(node => node.children);
  dataSource = new MatTreeNestedDataSource<OrganizationUnitDto>();

  constructor(
    private _organizationUnitServiceProxy: OrganizationUnitServiceProxy
  ) {
    this.BindOrganizationUnits();

  }

  hasChild = (_: number, node: OrganizationUnitDto) => !!node.children && node.children.length > 0;


  BindOrganizationUnits() {
    this._organizationUnitServiceProxy
      .GetOrganizationUnitTreeData().subscribe((result: OrganizationUnitDto[]) => {
        this.dataSource.data = result;
      });
  }

  haveChecked(node: OrganizationUnitDto) {
    return (
      node.code == "00001"
      ||
      node.code == "00001.00001"
      ||
      node.code == "00001.00001.00001"
      ||
      node.code == "00001.00001.00002"
      ||
      node.code == "00001.00001.00003"
    );
  }

  OrganizationUnits: OrganizationUnitDto[] = [];
  SelectionToggle(node: OrganizationUnitDto, checkbox: MatCheckboxChange) {
     if (checkbox.checked == true) {
      this.OrganizationUnits.push(node);
    } else {
      this.OrganizationUnits = this.OrganizationUnits.filter(s => s.id != node.id);
    }
    this.clicked.emit(this.OrganizationUnits);
  }

}

